import React, { Component } from "react";
import "./style.scss";

export default class InlineLoader extends Component {
  render() {
    return (
      <div className="inline-loader">
        <div className="loading-bar"></div>
        <div className="loading-bar"></div>
        <div className="loading-bar"></div>
        <div className="loading-bar"></div>
      </div>
    );
  }
}
